import React, { useState } from 'react'
import ModalMineralCountries from './ModalMineralCountries'

export default function ButtonShowModalMineralCountries({ mineralId }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel(event) {
    event.stopPropagation()
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
  }

  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="border-2 border-muted-500 bg-white p-2 hover:bg-muted-500"
      >
        في المنطقة العربية
      </button>
      <ModalMineralCountries
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        mineralId={mineralId}
      />
    </>
  )
}
